import { render } from "./Header_health.vue?vue&type=template&id=5bd2cc3b"
import script from "./Header_health.vue?vue&type=script&lang=js"
export * from "./Header_health.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__